import { useState } from "react";
import { useNavigate } from "react-router";
import TeachingsTable from "../../../components/TeachingsTable";
import RoundedCard from "../../../components/RoundedCard";
import { useTeachings } from "@/hooks/useTeachings";
import TeachingUploadDialog from "./TeachingUploadDialog";

type TeachingsDocumentTabProps = {
  detailPathPrefix?: string;
  description: string | null;
  reported?: boolean | null;
  showStatusColumn?: boolean;
  title: string;
};

const TEACHINGS_PAGE_SIZE = 10;

const TeachingsDocumentTab = ({
  detailPathPrefix = "",
  description,
  reported,
  showStatusColumn = true,
  title,
}: TeachingsDocumentTabProps) => {
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const {
    data: response,
    isError,
    isFetching,
    isLoading,
  } = useTeachings({
    page,
    page_size: TEACHINGS_PAGE_SIZE,
    reported,
  });

  const handleTeachingClick = (teachingId: string) => {
    void navigate(`${detailPathPrefix}undervisning/${teachingId}`);
  };

  return (
    <RoundedCard
      bodyClassName="p-0 mt-3"
      header={title}
      description={description}
      action={<TeachingUploadDialog />}
    >
      <TeachingsTable
        isError={isError}
        isLoading={isLoading}
        onTeachingClick={handleTeachingClick}
        showStatusColumn={showStatusColumn}
        teachings={response?.items ?? []}
        pagination={
          response
            ? {
                isDisabled: isFetching,
                onPageChange: setPage,
                page: response.page,
                total: response.total,
                totalPages: response.totalPages,
              }
            : undefined
        }
      />
    </RoundedCard>
  );
};

export default TeachingsDocumentTab;
